import * as z from 'zod';

export const LoginSchema = z.object({
  email_or_phone: z.string().email({
    message: 'Please enter a valid email!',
  }),
  password: z.string().min(6, {
    message: 'Password at least 8 charecter!',
  }),
});
